<template>
  <a-card :bordered="false" :bodyStyle="{padding:'20px'}" :headStyle="{borderBottom:'0px',paddingLeft:'20px'}">
    <a-row slot="title">
      <a-col :span="8">
        <span class="card-title">合作伙伴设置</span>
      </a-col>
      <a-col :span="8" :offset="8" style="text-align:right;">
        <a-button type="primary" @click="handleContent(0)">添加新内容</a-button>
      </a-col>
    </a-row>
    <custom-paging-dragging-list
      ref="table"
      rowKey="id"
      :columns="columns"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
      @draggable="onDraggable"
    >
      <div slot="indexSlots" slot-scope="rowItem">{{ rowItem.index + 1 }}</div>
      <div class="image-table" slot="imageSlots" slot-scope="rowItem">
        <CustomImage width="120" :imageUrl="rowItem.record.imageUrl"></CustomImage>
      </div>
      <div slot="action" slot-scope="rowItem">
        <a @click="handleContent(rowItem.record.id)">编辑</a>
        <a-divider type="vertical"/>
        <a-popconfirm
          title="你确定要删除这行内容吗?"
          @confirm="deleteEvent(rowItem.record)">
          <a-icon slot="icon" type="close-circle" style="color: red"/>
          <a>删除</a>
        </a-popconfirm>
      </div>
    </custom-paging-dragging-list>
  </a-card>
</template>

<script>
import CustomPagingDraggingList from '@/customComponents/CustomPagingDraggingList/CustomPagingDraggingList'

export default {
  name: 'CooperativePartner',
  components: {
    CustomPagingDraggingList
  },
  data() {
    return {
      columns: [
        {
          title: '排序',
          dataIndex: 'index',
          scopedSlots: { customRender: 'indexSlots' },
          width: '70px'
        },
        {
          title: '图片',
          dataIndex: 'imageUrl',
          slots: { title: 'customTitle' },
          width: '150px',
          scopedSlots: { customRender: 'imageSlots' }
        },
        {
          title: '图片描述',
          width: '28%',
          dataIndex: 'imageDescription'
        },
        {
          title: '内容类型',
          dataIndex: 'typeName'
        },
        {
          title: '修改时间',
          dataIndex: 'gmtModified'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '90px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      loadPromise: params => this.getListPromise(params),
      queryParams: {}
    }
  },
  activated() {
    this.$refs.table.refresh(true)
  },
  methods: {
    handleContent(id) {
      let params = {}
      if (id) {
        params.id = id
      }
      this.getLogUtils().errorWithTag('params', params)
      this.openNewPage('AddCooperativePartner', params)
    },
    // 删除
    deleteEvent(item) {
      this.getHttpServices().getUserService().post('pc/v2/partnership/delete/' + item.id)
        .then(res => {
          this.$refs.table.refresh(true)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 拖拽排序功能
    onDraggable(params) {
      let idList = new Array
      idList = params.dataList.map((item) => {
        return item.id
      })
      let data = {
        pageNum: params.pageNo,
        pageSize: params.pageSize,
        idList: idList
      }
      this.getHttpServices().getUserService().post('pc/v2/partnership/orderBy', data).then(res => {
        this.$message.success('排序成功')
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getListPromise(params) {
      return this.getHttpServices().getUserService().post('pc/v2/partnership/query', params)
    }
  }
}
</script>

<style lang="less">
</style>